// inputFields.js
const InputFields = [
  {
    name: "image",
    type: "image",
    label: "Room Image",
  },
  {
    name: "name",
    type: "text",
    label: "Room Name",
  },
  {
    name: "description",
    type: "text",
    label: "Description",
  },
  {
    name: "category_name",
    type: "dynamic_select",
    label: "Category",
    placeholder: "",
    options: [],
  },
];

export default InputFields;
